import React from 'react';
import { Spinner } from 'react-bootstrap';

const BasketPreloader = () => {
    return (  
        <div style={{
            width:"auto",
            height:"50%",
            marginTop:"30%",
            display:"flex",
            flexDirection:"column",
            gap:"10px",
            justifyContent:"center",
            alignItems:"center"
            
        }}>
            <Spinner animation="border" variant="warning"/>
            <p>
                در حال بررسی اطلاعات
            </p>
        </div>
    );
}
 
export default BasketPreloader;